<template>
  <div class="simple-text">
    <div class="inner-html-text" v-html="text"/>
  </div>
</template>

<script setup lang="ts">
  import type { WithTypename } from '~/types/graphql';
  import type { SimpleText } from '~/types/strapi';

  type SimpleTextComponent = WithTypename<SimpleText>;

  const { component } = defineProps<{
    component: SimpleTextComponent;
    index: number;
  }>();

  const text = component.text;
</script> 

<style lang="scss" scoped>
  .simple-text {
    &:deep(h1) {
      @apply mb-6;
    }

    &:deep(h2) {
      @apply mb-6;
    }

    &:deep(h3) {
      @apply mb-6;
    }

    &:deep(p) {
      @apply mb-6;
      @apply text-medium-normal;
    }

    &:deep(a) {
      @apply text-accent underline;
    }
  }
</style>